import React from 'react';

import {
  useCustomerDetailsView,
  resolveEnvironment,
  CustomerDetailsForm /* already on v2 */,
} from '@fingermarkglobal/cringer.components';

const CustomCustomerDetailsView = () => {
  const {
    t,
    inputError = '',
    lastName,
    firstName,
    fullName,
    email,
    phoneNumber,
    layout,
    currentSettings,
    firstNameSettings,
    lastNameSettings,
    fullNameSettings,
    phoneNumberSettings,
    emailSettings,
    showEmail,
    emailCodes,
    showNameFields,
    showFullNameField,
    showPhoneNumberField,
    receiveMarketingEmail,
    receiveMarketingEmailSettings,
    showReceiveMarketingEmail,
    showEmailDescription,
    showSubtitle,
    isEmailAutoFocus,
    showNumbers,
    firstNameError,
    lastNameError,
    fullNameError,
    emailError,
    phoneNumberError,
  } = useCustomerDetailsView({
    displayRequiredLabel: false,
    showPrimaryAction: true,
    showEmail: true,
    isFirstNameRequired: true,
    isLastNameRequired: true,
    showCategoriesHeader: true,
  });

  resolveEnvironment('', () => {});

  return (
    <div data-test="customer-details-screen" className="customer-details-view">
      <div className="customer-details-view--title">{t('customerDetailsFormTitle')}</div>
      {showSubtitle && (
        <div className="customer-details-view--subtitle">{t('customerDetailsFormSubTitle')}</div>
      )}
      <CustomerDetailsForm
        t={t}
        layout={layout}
        email={email}
        lastName={lastName}
        firstName={firstName}
        fullName={fullName}
        phoneNumber={phoneNumber}
        emailSettings={emailSettings}
        showEmail={showEmail}
        emailCodes={emailCodes}
        showNameFields={showNameFields}
        showFullNameField={showFullNameField}
        showPhoneNumberField={showPhoneNumberField}
        showEmailDescription={showEmailDescription}
        currentSettings={currentSettings}
        firstNameSettings={firstNameSettings}
        lastNameSettings={lastNameSettings}
        fullNameSettings={fullNameSettings}
        phoneNumberSettings={phoneNumberSettings}
        receiveMarketingEmail={receiveMarketingEmail}
        receiveMarketingEmailSettings={receiveMarketingEmailSettings}
        showReceiveMarketingEmail={showReceiveMarketingEmail}
        isEmailAutoFocus={isEmailAutoFocus}
        inputError={inputError}
        showNumbers={showNumbers}
        firstNameError={firstNameError}
        lastNameError={lastNameError}
        fullNameError={fullNameError}
        emailError={emailError}
        phoneNumberError={phoneNumberError}
      />
    </div>
  );
};

export { CustomCustomerDetailsView };
